// You can write more code here

/* START OF COMPILED CODE */

import UserComponent from "./UserComponent";
import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class FitTextToBounds extends UserComponent {

  constructor(gameObject: Phaser.GameObjects.Text | Phaser.GameObjects.BitmapText) {
    super(gameObject);

    this.gameObject = gameObject;
    (gameObject as any)["__FitTextToBounds"] = this;

    /* START-USER-CTR-CODE */
    this.gameObject.setData('textFitter', this);
    /* END-USER-CTR-CODE */
  }

  static getComponent(gameObject: Phaser.GameObjects.Text | Phaser.GameObjects.BitmapText): FitTextToBounds {
    return (gameObject as any)["__FitTextToBounds"];
  }

  private gameObject: Phaser.GameObjects.Text | Phaser.GameObjects.BitmapText;
  public maxWidth: number = 0;
  public maxHeight: number = 0;
  public minFontSize: number = 0;
  public multiLine: boolean = false;
  public constrainByWidth: boolean = false;
  public constrainByHeight: boolean = false;

  /* START-USER-CODE */
  private defaultFontSize: number = 10;
  private currentText: string = '';

  awake() {
    if (this.gameObject instanceof Phaser.GameObjects.Text) {
      this.defaultFontSize = this.gameObject.getTextMetrics().fontSize;
      console.log("What is default font size", this.defaultFontSize);
      // this.gameObject.setWordWrapCallback(this.wordWrap, this);
    } else if (this.gameObject instanceof Phaser.GameObjects.BitmapText) {
      this.defaultFontSize = this.gameObject.fontSize;
    }
    this.sizeText();
  }

  update(time: number, delta: number) {
    if (this.currentText != this.gameObject.text) {
      this.sizeText();
    }
  }

  public sizeText() {
    this.currentText = this.gameObject.text;
    this.gameObject.setFontSize(this.defaultFontSize);

    let fontSize: number = this.defaultFontSize;

    if (this.constrainByWidth) {
      while (this.gameObject.width > this.maxWidth) {
        fontSize = fontSize - 1;
        if (fontSize < this.minFontSize) {
          break;
        }
        this.gameObject.setFontSize(fontSize);
      }
    }

    if (this.constrainByHeight) {
      while (this.gameObject.height > this.maxHeight) {
        fontSize = fontSize - 1;
        if (fontSize < this.minFontSize) {
          break;
        }
        this.gameObject.setFontSize(fontSize);
      }
    }

    // Future Idea
    // Measure copy width against text max width.
    // Try and wrap by one extra line if allowed to by max lines.
    // Check if it fits.
    // If allowed wrap again by one extra line, otherwise
    // Shrink to fit by width and then by height.
  }

  protected wordWrap(text: string, textObject: Phaser.GameObjects.Text) {}

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
